import { render, staticRenderFns } from "./v4.vue?vue&type=template&id=6b4334da&scoped=true&"
import script from "./v4.vue?vue&type=script&lang=js&"
export * from "./v4.vue?vue&type=script&lang=js&"
import style0 from "./v4.vue?vue&type=style&index=0&id=6b4334da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4334da",
  null
  
)

export default component.exports